/**
 * Validates the simulation name input field in the new simulation modal
 * @param value The simulation name to validate
 * @returns A list of errors if any, otherwise an empty array
 */
export const validateSimulationName = (value: string): string[] => {
  const errors = [];

  if (value.trim().length < 1) {
    errors.push('Name can not be empty');
  }

  const specialCharactersRegex = /[!@#$%^&*()\+={}\[\]\|\\:;"'<>,.?/~`]/;
  if (specialCharactersRegex.test(value)) {
    errors.push('Special characters are not allowed.');
  }

  return errors;
};
